import * as React from "react";
import { styled } from "@mui/system";
import MUIDrawer from "@mui/material/Drawer";
import { DrawerProps as DrawerPropsMUI } from "@mui/material/Drawer";
export interface DrawerProps extends DrawerPropsMUI {}

interface DrawerPropsExtended extends DrawerProps {
  width?: number | string;
  component?: React.ElementType;
}

const DrawerRoot = styled(
  React.forwardRef<HTMLDivElement, DrawerPropsExtended>((props, ref) => (
    <MUIDrawer ref={ref} {...props} />
  )),
  {
    name: "Drawer",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "width" && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, width }) => ({
  "&.MuiDrawer-root .MuiDrawer-paper": {
    background: theme.palette.primary.surfaceDefault,
    boxShadow:
      theme.name === "fic" ? "0px 20px 40px 0px #15293526" : theme.shadows[2]
  },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorLeft": {
    background: theme.palette.primary.surfaceDefault,
    width: width,
    boxShadow: theme.shadows[2]
  },
  "&.MuiDrawer-root .MuiDrawer-paperAnchorRight": {
    boxShadow:
      theme.name === "fic" ? "0px 20px 40px 0px #15293526" : theme.shadows[2],
    background: theme.palette.primary.surfaceDefault,
    width: width
  }
}));

export const Drawer = React.forwardRef<HTMLDivElement, DrawerPropsExtended>(
  function Drawer(props, ref) {
    return <DrawerRoot {...props} ref={ref} />;
  }
) as React.FC<DrawerPropsExtended>;
